export default function DownloadSection() {
  return (
    <section id="download-section" className="py-16 md:py-20 bg-background-100">
      <div className="container-page">
        <div className="text-center mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold mb-4">
            立即体验
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 font-heading mb-4">
            下载蘑菇视频App
          </h2>
          <p className="text-foreground-500 max-w-2xl mx-auto text-base">
            选择适合你设备的版本，即刻开启精彩短视频之旅
          </p>
        </div>

        <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6">
          {[
            {
              icon: 'ri-android-line',
              title: '安卓版',
              version: 'v5.2.0',
              size: '82MB',
              desc: '适用于Android 8.0及以上系统',
              tag: '推荐',
            },
            {
              icon: 'ri-apple-line',
              title: 'iOS版',
              version: 'v5.2.0',
              size: '180MB',
              desc: '适用于iOS 14.0及以上系统',
              tag: '',
            },
            {
              icon: 'ri-computer-line',
              title: '电脑版',
              version: 'v2.1.0',
              size: '126MB',
              desc: '支持Windows 10/11及macOS',
              tag: '',
            },
          ].map((item) => (
            <div
              key={item.title}
              className="relative bg-background-50 rounded-xl border border-background-200/70 p-8 text-center flex flex-col items-center"
            >
              {item.tag && (
                <span className="absolute top-3 right-3 px-2.5 py-0.5 rounded-full bg-primary-500 text-white text-xs font-medium">
                  {item.tag}
                </span>
              )}
              <div className="w-16 h-16 rounded-2xl bg-primary-100 flex items-center justify-center mb-5">
                <i className={`${item.icon} text-2xl text-primary-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-foreground-900 mb-2 font-heading">{item.title}</h3>
              <div className="flex items-center gap-3 text-sm text-foreground-400 mb-3">
                <span>{item.version}</span>
                <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
                <span>{item.size}</span>
              </div>
              <p className="text-sm text-foreground-500 mb-6">{item.desc}</p>
              <button className="w-full py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-full text-sm transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-download-cloud-2-line mr-1.5"></i>
                下载安装
              </button>
            </div>
          ))}
        </div>

        <div className="mt-10 flex items-center justify-center gap-6 flex-wrap">
          <div className="flex items-center gap-2 text-sm text-foreground-500">
            <i className="ri-shield-check-line text-primary-500"></i>
            <span>官方正版，安全无毒</span>
          </div>
          <div className="flex items-center gap-2 text-sm text-foreground-500">
            <i className="ri-refresh-line text-primary-500"></i>
            <span>持续更新，功能完善</span>
          </div>
          <div className="flex items-center gap-2 text-sm text-foreground-500">
            <i className="ri-customer-service-line text-primary-500"></i>
            <span>7×12小时技术支持</span>
          </div>
        </div>
      </div>
    </section>
  );
}